
@if (!isLoading) {
  <div [class]="brandClass" [ngClass]="(isQrScannerRunning$ | async) ? 'qr-scanner-enabled' : ''">
    @if (!isHighlights && ((isQrScannerRunning$ | async) === false)) {
      <nav class="role-icon-container">
        @for (button of loginRoleTypes; track button.mode) {
          <a
            [routerLink]="button.route"
            [id]="button.id"
            [attr.aria-label]="button.subtitle + ' login ' + button.currentPage"
            routerLinkActive="role-link-active"
            class="role-link">
            <zbp-role-button [iconName]="button.zbpIconName"></zbp-role-button>
            <span [id]="button.id + '-label'" class="role-label">{{button.subtitle}}</span>
          </a>
        }
      </nav>
    }
    @if ((isQrScannerRunning$ | async) === false) {
      <header id="loginFormWelcomeHeader" class="row mt-4 header-container">
        <h1 id="pageTitle" class="h1 text-center">{{welcomeText}}</h1>
        <h2 id="titleSubtext" class="h2 text-center">{{subtitleText}}</h2>
      </header>
      <form id="loginForm" class="w-100 login-form" [class.px-5]="isHighlights" [formGroup]="loginForm" (ngSubmit)="login()">
        @if (errorMessage) {
          <div
            role="alert"
            class="row d-block mx-auto w-100 alert alert-danger fw-bold text-uppercase text-center">
            <i class="w-auto px-0 fa fa-circle-exclamation text-danger"></i>
            <span class="w-auto ps-1">{{ errorMessage }}</span>
          </div>
        }
        <div aria-live="polite">
          <div class="row input-group mx-auto w-100">
            <label for="username" class="form-label form-label-hfc" [class.label-error]="(userNameError$ | async)">
              {{ currentModeContent.userNameFieldName }}
            </label>
            <input id="username" class="form-control form-control-hfc" type="email" spellcheck="false" tabindex="0"
              formControlName="userName" [class.is-invalid]="(userNameError$ | async)" data-cy="login-username"
              [attr.aria-invalid]="(userNameError$ | async)"
              [attr.aria-describedby]="(userNameError$ | async) ? 'usernameFeedback' : ''">
            <div id="usernameFeedback" class="invalid-feedback text-uppercase" [class.d-block]="(userNameError$ | async)">
              {{ currentModeContent.userNameFieldName }} required
            </div>
          </div>
          <div class="row input-group mx-auto w-100">
            <label for="password" class="form-label form-label-hfc" [class.label-error]="(passwordError$ | async)">Password</label>
            <div class="loginPasswordGroup m-0 p-0">
              <input id="password" class="form-control form-control-hfc" [type]="showPassword ? 'text' : 'password'"
                autocomplete="off" spellcheck="false" tabindex="0" formControlName="password"
                [class.is-invalid]="(passwordError$ | async)" data-cy="login-password"
                [attr.aria-invalid]="(passwordError$ | async)"
                [attr.aria-describedby]="(passwordError$ | async) ? 'passwordFeedback' : ''">
              <button id="showPasswordButton" class="p-0 m-0 h-100" type="button"
                [class.is-invalid]="(passwordError$ | async)" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password' "
                (click)="toggleShowPassword()">
                <i class="fa" [class.fa-eye-slash]="!showPassword" [class.fa-eye]="showPassword"></i>
              </button>
            </div>
            <div id="passwordFeedback" class="invalid-feedback text-uppercase" [class.d-block]="(passwordError$ | async)">
              Password required
            </div>
          </div>
          @if (loginFormMode === 'student' && loginForm.get('schoolId')) {
            <div class="row input-group mx-auto w-100">
              <label for="schoolId" class="form-label form-label-hfc" [class.label-error]="(schoolIdError$ | async)">School ID</label>
              <input
                id="schoolId"
                class="form-control form-control-hfc"
                type="text"
                spellcheck="false"
                tabindex="0"
                formControlName="schoolId"
                [class.is-invalid]="(schoolIdError$ | async)"
                [attr.aria-invalid]="(schoolIdError$ | async)"
                [attr.aria-describedby]="(schoolIdError$ | async) ? 'schoolIdFeedback' : ''"
                data-cy="login-schoolid"
                >
              <div id="schoolIdFeedback" class="invalid-feedback text-uppercase" [class.d-block]="(schoolIdError$ | async)">
                School ID required
              </div>
            </div>
          }
        </div>
        <div class="row d-flex flex-column mx-auto w-100">
          <zbp-button-component
            id="loginButton"
            type="submit"
            label="Log In"
            theme="primary"
            data-cy="login-submit-button"
            class="login-button"
            [showSpinner]="loginProcessing"
            [fullWidth]="true"
            [topBottomPaddingSpacingS]="true"
            >
          </zbp-button-component>
          <button id="forgotPasswordButton"
            type="button"
            class="btn btn-link red-text-link"
            (click)="handleForgotPassword()">
            Forgot your password?
          </button>
        </div>
      </form>
    }
    @if (!isHighlights && ((isQrScannerRunning$ | async) === false)) {
      <zbp-sso-form></zbp-sso-form>
    }
    <!-- Student QR login aside -->
    <!-- Renders the QR Instructions and toggles the form to the scanner when user clicks the 'Login with QR Code' button  -->
    @if (loginFormMode === studentPageRole) {
      <zbp-branded-qr-code-login
        id="studentQrLoginAside"
        [ngClass]="(isQrScannerRunning$ | async) ? 'scanning-in-process' : ''"
        [isQrScannerRunning$]="isQrScannerRunning$"
      ></zbp-branded-qr-code-login>
    }
  </div>
}
